<template>
  <div class="template-padding">
    <div class="crewing">
      <div class="row p-1">
        <div class="col col-sm-10">
          <h4>Crew List</h4>
        </div>

        <!--                <div class="col col-sm-2">-->
        <!--                    <button type="button" class="btn btn-outline-primary btn-sm float-right" data-toggle="modal" data-target="#createCrewModal">-->
        <!--                        <strong>ADD NEW</strong>-->
        <!--                    </button>-->
        <!--                </div>-->
      </div>

      <form
        class="row pl-3"
        @submit.prevent="search"
      >
        <div class="col col-sm-8 pl-0">
          <div class="input-group mb-3 rounded-circle small">
            <div class="input-group-prepend">
              <button
                class="btn btn-secondary btn-sm disabled no-pointer "
                type="button"
              >
                Search By:
              </button>
            </div>

            <div class="col-sm-4">
              <select
                class="form-control custom-select"
                id="searchValueKey"
                @change="setKey"
                v-model="searchKey"
                required
              >
                <option
                  selected
                  value="all"
                >
                  All
                </option>
                <option value="last_name">
                  Last Name
                </option>
                <option value="first_name">
                  First Name
                </option>'
                <option value="middle_name">
                  Middle Name
                </option>
                <option value="crewipn">
                  Crew IPN
                </option>
                <option value="rank">
                  Rank
                </option>
              </select>
            </div>

            <input
              type="text"
              class="form-control"
              id="searchValue"
              aria-label="Search"
              aria-describedby="basic-addon2"
              data-toggle="popover"
              data-trigger="hover"
              title="SEARCH"
              data-content="Search Crew Here"
              placeholder="Type Search Here..."
              data-placement="bottom"
              v-model="searchValue"
            >

            <div class="input-group-append">
              <button
                type="submit"
                class="btn btn-secondary"
              >
                <i class="fa fa-search" />
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-2 offset-2">
          <div class="input-group mb-3 rounded-circle small">
            <select
              class="form-control custom-select"
              @change="setRecords"
              v-model="records"
            >
              <option
                v-for="page in numberOfPages"
                :key="page"
                :value="page"
                :selected="page === records"
              >
                {{ page }} Records
              </option>
            </select>
          </div>
        </div>
      </form>

      <table class="table table-hover table-bordered">
        <thead>
          <tr class="table-header">
            <th
              scope="col"
              class="p-1"
              width="20px;"
            >
              #
            </th>
            <th
              scope="col"
              class="col-actions p-1"
            >
              APPLICANT NO
            </th>
            <th
              scope="col"
              class="col-actions p-1"
            >
              CREWCODE
            </th>
            <th
              scope="col"
              class="col-actions p-1"
            >
              CREWIPN
            </th>
            <th
              scope="col"
              class="p-sm-1"
            >
              CREW NAME
            </th>
            <th
              scope="col"
              class="p-1"
            >
              RANK
            </th>
            <th
              scope="col"
              class="col-actions-sm p-1"
            >
              Action
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(crew,index) in crews.data"
            :key="crew.id"
          >
            <th
              scope="row"
              class="p-1"
            >
              {{ ((currentCrewPage-1) * crewPerPage ) + (index + 1) }}
            </th>
            <td class="p-1">
              {{ crew.applicantno }}
            </td>
            <td class="p-1">
              {{ crew.crewcode }}
            </td>
            <td class="p-1">
              {{ crew.crewipn }}
            </td>
            <td class="p-1">
              {{ crew.crewname }}
            </td>
            <td
              class="p-1"
              :title="crew.rankName"
            >
              {{ crew.rankAlias }}
            </td>
            <td class="p-1">
              <button
                type="button"
                class="btn btn-outline-primary btn-sm btn btn-sm btn-xs btn-outline-info mr-1 font-weight-bolder action"
                @click="showCrew(crew.id)"
              >
                <i class="fa fa-eye" />
                View
              </button>
              <!--                        &nbsp;-->
              <!--                        <button class="btn btn-outline-primary btn-sm action font-weight-bolder" @click="editCrew(crew.id)">-->
              <!--                            <i class="fa fa-edit"></i>-->
              <!--                            edit-->
              <!--                        </button>-->

              <!--                        <button v-if="userLogin.user_type_id === 1"-->
              <!--                                class="btn btn-outline-danger btn-sm action font-weight-bolder"-->
              <!--                                @click="removeCrew(crew.id)">-->
              <!--                            <i class="fa fa-trash-alt"></i>-->
              <!--                            delete-->
              <!--                        </button>-->
            </td>
          </tr>
        </tbody>
      </table>

      <pagination
        :data="crews"
        @pagination-change-page="getResults"
        :limit="5"
        :show-disabled="false"
      >
        <span slot="prev-nav"><i class="fa fa-angle-double-left" />Previous</span>
        <span slot="next-nav">Next <i class="fa fa-angle-double-right" /></span>
      </pagination>
    </div>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { formMixins } from '../../mixins/formMixins';

    export default {
        mixins : [formMixins],
        name: 'IndexCrew',
        data() {
            return {
                numberOfPages: [10, 15, 20, 50, 100, 200],
                searchKey :'all',
                searchValue :'',
                records: 10
            }
        },

        methods : {
            ...mapActions(['getCrewPaginated','deleteCrew']),
            async getResults(page= 1,searchValue = this.searchValue,searchKey = this.searchKey,records = this.records) {
                this.getCrewPaginated({page,searchValue,searchKey,records});
            },

            showCrew(id) {
                this.$router.push(`/crew/${id}`).catch(()=>{});
            },

            editCrew(id) {
                this.$router.push(`/editCrew/${id}`).catch(()=>{});
            },

            setKey(e) {
                this.searchKey = e.target.value;
            },

            setRecords(e) {
                this.records = e.target.value;
                let page = page = 1;
                let searchValue = this.searchValue;
                let searchKey = this.searchKey;
                let records = this.records;
                this.getCrewPaginated({page,searchValue,searchKey,records});
            },

            search() {
                let page = page = 1;
                let searchValue = this.searchValue;
                let searchKey = this.searchKey;
                let records = this.records;
                this.getCrewPaginated({page,searchValue,searchKey,records});
            },

            async removeCrew(id) {
                if(await this.deleteAlert('Are you sure you want to delete this record?')){
                    this.deleteCrew(id);
                }
            }
        },

        computed : {
            ...mapGetters(['crews','currentCrewPage','crewPerPage','userLogin']),
        },

        mounted() {
            $(document).ready(function(){
                $('[data-toggle="popover"]').popover();
            });
        },

      async  created() {
            let page = page = 1;
            let searchValue = this.searchValue;
            let searchKey = this.searchKey;
            let records = this.records;
            this.getCrewPaginated({page,searchValue,searchKey,records});
          },
    };
</script>


<style scoped>
    .action{
        font-size: 0.7em;
    }

    .table-responsive tr{
        text-align: center;
    }

    .no-pointer {
        pointer-events: none;
    }

    table tbody td{
        font-weight: normal;
    }

</style>
